export { default } from './TabNew';
